import * as React from "react"
import {BasicDriverFragment, SetBookingDriver} from "../graphql/queries"
import {SaveResetButtons, SectionProps, UpdatableFormSection} from "./UpdateBookingWizard"
import {Form} from "semantic-ui-react"
import {DriverPicker} from "./DriverPicker"
import {GraphQL} from "../graphql"
import {errorUnionToEither} from "../graphql/errors"

interface DriverSectionState {
  driver: BasicDriverFragment | null
}

export function DriverSelectSection(props: SectionProps) {
  const state: DriverSectionState = {
    driver: props.booking.driver,
  }
  return (
    <UpdatableFormSection
      {...props}
      state={state}
      header="Driver"
      render={(params) => {
        const {state, mapState} = params
        return (
          <Form>
            <DriverPicker
              driver={state.driver}
              onDriver={
                mapState &&
                ((driver) => {
                  mapState((state) => ({driver}))
                })
              }
            />
            {mapState && (
              <Form.Group>
                <SaveResetButtons
                  {...props}
                  onSave={async () => {
                    const ret = await props.modalStore.applyModal({
                      pending: ["Saving driver", "Saving driver..."],
                      error: (m) => ["Saving driver failed", m],
                      action: async () => {
                        const data = await GraphQL.mutate(SetBookingDriver, {
                          id: props.booking.id,
                          driverId: state.driver ? state.driver.id : null,
                        })
                        return errorUnionToEither(data.setBookingDriver)
                      },
                    })
                    return ret.isRight()
                  }}
                />
              </Form.Group>
            )}
          </Form>
        )
      }}
    />
  )
}



// WEBPACK FOOTER //
// ./src/components/BookingDriverSelectSection.tsx